import React from 'react';
import SearchInput from '../../Inputs/SearchInput';
import {appText} from '../../../assets/text/appText';
import Button from '../../Buttons/Button';
import './styles.css';
import {useLocation, useNavigate} from 'react-router-dom';

interface AnalyticsTab {
  title: string;
  link: string;
}

interface Props {
  onExport: () => void;
  search: string;
  setSearch: (v: string) => void;
  tabs: AnalyticsTab[];
}

const AnalyticsNavigationTabs = React.memo(
  ({onExport, search, setSearch, tabs}: Props) => {
    const navigate = useNavigate();
    const location = useLocation();

    const onNav = (link: string) => {
      navigate(link);
    };

    return (
      <div className="NavigationTabs">
        <div className="TabsContainer">
          {tabs.map(tab => (
            <Button
              key={tab.title}
              title={tab.title}
              onClick={() => onNav(tab.link)}
              uiType="hollow"
              className={location.pathname === tab.link ? 'ButtonActive' : ''}
            />
          ))}
        </div>
        <div className="SearchExport">
          <SearchInput value={search} onChange={setSearch} />
          <Button
            onClick={onExport}
            icon="icon-download_ic"
            title={appText.export}
            className="ExportButton"
          />
        </div>
      </div>
    );
  },
);

export default AnalyticsNavigationTabs;
